import Card from 'react-bootstrap/Card';
const cardImage = require.context('../img/cards', false, /\.(png|jpe?g|webp|svg)$/);


function CardService({ image, name, description }) {
  const getCardsSrc = (fileName) => {
    if (!fileName) return null;
    try {
      return cardImage(`./${fileName}`);
    } catch (err) {
      return `${process.env.PUBLIC_URL}/img/cards/${fileName}`;
    }
  };
  const src = getCardsSrc(image);

  return (
    <Card>
      <Card.Img variant="top" src={src} />
      <Card.Body>
        <Card.Title>{name}</Card.Title>
        <Card.Text>
          {description}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default CardService;